import {Component} from '@angular/core';
import {NavController, NavParams, PopoverController, ToastController} from 'ionic-angular';
import {KontakteDetailsPage} from "../kontakte-details/kontakte-details";
import {PopoverAddContactComponent} from "../../components/popover-add-contact/popover-add-contact";
import {Contacts} from "@ionic-native/contacts";
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {blobToDataURL} from "blob-util";
import {Subscription} from "rxjs/Subscription";
import {GlobalProvider} from "../../providers/global/global";
import {ContactService} from "../../store/contact/contact.service";
import {ContactEntity, contactType} from "../../store/contact/contact.entity";

// import vcf from "vcardjs/src/vcard.js";

/**
 * Generated class for the KontakteKundenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-kontakte-kunden',
  templateUrl: 'kontakte-kunden.html',
})
export class KontakteKundenPage {

  public contactType: contactType;
  public contacts: Array<any> = [];
  public contactTitle: string;
  private _customerSubsription: Subscription;
  public isBrowser: boolean = false;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private popoverCtrl: PopoverController,
              private dataProvider: DataProvider,
              private contactProvider: Contacts,
              private contactService: ContactService,
              private toastCtrl: ToastController,
              private globalProvider: GlobalProvider
  ) {
    this.isBrowser = this.globalProvider.isBrowser();
    this.contactType = this.navParams.get('type');


  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad KontakteKundenPage');
  }

  ionViewWillEnter(){
    this._customerSubsription = this.contactService.getAllByType(this.contactType)
      .subscribe((contacts) => {
        if(contacts && contacts.length > 0){
          this.contacts = contacts;
          this.contacts.forEach((contact) => {

            if(contact._attachments){
              let  logoAttachmentName = null;
              for(let attachmentName in contact._attachments){
                if(attachmentName.indexOf('logo') !== -1){
                  logoAttachmentName = attachmentName;
                  break;
                }
              }
              if(logoAttachmentName){
                this.dataProvider.getAttachment(contact._id, logoAttachmentName)
                  .then((logo) => {
                    blobToDataURL(logo)
                      .then((base64) => {
                        contact.logo = base64;
                      })
                  })
              }
            }
          })
        }
      })

    switch(this.contactType) {
      case 1:
        this.contactTitle = "Kunde";
        break;
      case 2:
        this.contactTitle = "Auftragnehmer";
        break;
    }
  }

  ionViewWillLeave() {
    this._customerSubsription.unsubscribe();
  }

  public openKontaktDetails(contact: number): void {
    this.navCtrl.push(KontakteDetailsPage, {contact: contact});
  }

  public addContact(ev: Event): void {
    let _newContactPopover = this.popoverCtrl.create(PopoverAddContactComponent);
    _newContactPopover.onDidDismiss((data: any) => {
      if(data && data.type){
        switch (data.type) {
          case 'import':
            this.importContact();
            break;
          case 'new':
            this.createNew();
            break;
          case 'vcard':
            this._importVCard(data.file);
            break;
        }
      }
    })
    _newContactPopover.present({
      ev: ev
    });
  }


  private _importVCard(file:File):void {
    console.log(file);
    let fileReader:FileReader = new FileReader();
    fileReader.readAsText(file);
    fileReader.onloadend = function(e){
      // you can perform an action with data read here
      // as an example i am just splitting strings by spaces
      // let VCF = new vcf();
      // VCF.parse(fileReader.result, function(vcard) {
      //   // this function is called with a VCard instance.
      //   // If the input contains more than one vCard, it is called multiple times.
      //   console.log("Formatted name", vcard.fn);
      //   console.log("Names", JSON.stringify(vcard.n));
	  //
      //   console.log(vcard);
      // });


    };
  }

  private importContact(): void {

    this.contactProvider.pickContact()
      .then((importedContact) => {
        console.dir(importedContact);
        let lastName = importedContact.name.familyName ? importedContact.name.familyName : '';
        let firstName = importedContact.name.givenName ? importedContact.name.givenName : '';
        let street = importedContact.addresses && importedContact.addresses.length !== 0 ? importedContact.addresses[0].streetAddress : '';
        let zipCode = importedContact.addresses && importedContact.addresses.length !== 0 ? importedContact.addresses[0].postalCode : '';
        let city = importedContact.addresses && importedContact.addresses.length !== 0 ? importedContact.addresses[0].locality : '';

        let company = importedContact.organizations && importedContact.organizations.length !== 0 ? importedContact.organizations[0].name : '';
        let mail = importedContact.emails && importedContact.emails.length !== 0 ? importedContact.emails[0].value : '';

        let fax = '';
        importedContact.phoneNumbers.forEach((phoneNumber) => {
          if(phoneNumber.type.toLowerCase().indexOf('fax') !== -1){
            fax = phoneNumber.value;
            return;
          }
        });

        let tel = '';
        importedContact.phoneNumbers.forEach((phoneNumber) => {
          if(phoneNumber.type.toLowerCase().indexOf('fax') === -1){
            tel = phoneNumber.value;
            return;
          }
        });

        let web = importedContact.urls && importedContact.urls.length !== 0 ? importedContact.urls[0].value : '';

        let newContact:ContactEntity = {
          docType: 'contact',
          type: this.contactType,
          docName: this.contactType === 1 ? 'Kunde' : 'Auftragnehmer',
          system: false,
          company: company,
          firstName: firstName,
          lastName: lastName,
          street: street,
          zip: zipCode,
          city: city,
          tel: tel,
          fax: fax,
          mail: mail,
          web: web,
        };

        this.contactService.add(newContact, false);
        this.navCtrl.push(KontakteDetailsPage, {contact: newContact, editMode: true});

        // this.dataProvider.createDocumentWithoutInit(newContact)
        //   .then((contact) => {
        //     this.navCtrl.push(KontakteDetailsPage, {contact: contact, editMode: true});
        //   }, (error) => {
        //     this.toastCtrl.create({
        //       message: 'Fehler beim Kontaktimport! Bitte versuchen Sie es erneut.',
        //       duration: 1000,
        //       position: 'bottom'
        //     }).present();
        //   })

      }, (error) => {
        console.log('error while import contact from addressbook');
        console.dir(error);
      })
  }

  private createNew(): void {

    let newContact = {
      logo: null,
      company: null,
      firstName: null,
      lastName: null,
      docType: 'contact',
      type: this.contactType
    };
    this.navCtrl.push(KontakteDetailsPage, {contact: newContact, editMode: true})
  }

  // If you work with AOT this method must be present, even if empty!
  // Otherwise 'ng build --prod' will optimize away any calls to ngOnDestroy,
  // even if the method is added by the @AutoUnsubscribe decorator
  ngOnDestroy() {
    // You can also do whatever you need here
  }

}



// WEBPACK FOOTER //
// ./src/pages/kontakte-kunden/kontakte-kunden.ts